import { render, staticRenderFns } from "./nft-attributes.vue?vue&type=template&id=1ad8dca7&"
import script from "./nft-attributes.vue?vue&type=script&lang=js&"
export * from "./nft-attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports